import { WS_EVENTS } from "./constants";

/** CustomEvent names dispatchés par WebSocketProvider (`ws:<event>`). */
export const WS_DOM_TICKETING = [
  `ws:${WS_EVENTS.TICKETING_TICKET_CREATED}`,
  `ws:${WS_EVENTS.TICKETING_TICKET_UPDATED}`,
  `ws:${WS_EVENTS.TICKETING_TICKET_ASSIGNED}`,
  `ws:${WS_EVENTS.TICKETING_TICKET_MERGED}`,
  `ws:${WS_EVENTS.TICKETING_TICKET_RESOLVED}`,
  `ws:${WS_EVENTS.TICKETING_TICKET_DELETED}`,
] as const;

export const WS_DOM_CART = [
  `ws:${WS_EVENTS.CART_ORDER_CREATED}`,
  `ws:${WS_EVENTS.CART_ORDER_STATUS_CHANGED}`,
] as const;

export const WS_DOM_CART_BAR = [
  `ws:${WS_EVENTS.CART_BAR_ORDER_CREATED}`,
  `ws:${WS_EVENTS.CART_BAR_ORDER_STATUS_CHANGED}`,
] as const;

export const WS_DOM_ORDERS = [...WS_DOM_CART, ...WS_DOM_CART_BAR] as const;

export const WS_DOM_SERVICES = [
  `ws:${WS_EVENTS.SERVICES_RESERVATION_CREATED}`,
  `ws:${WS_EVENTS.SERVICES_RESERVATION_CANCELLED}`,
  `ws:${WS_EVENTS.SERVICES_RESERVATION_UPDATED}`,
  `ws:${WS_EVENTS.SERVICES_RESERVATION_REMINDER}`,
  `ws:${WS_EVENTS.SERVICES_SLOT_CHANGED}`,
] as const;

export const WS_DOM_LIST = [
  `ws:${WS_EVENTS.LIST_APPOINTMENT_ARRIVED}`,
  `ws:${WS_EVENTS.LIST_APPOINTMENT_DELETED}`,
  `ws:${WS_EVENTS.LIST_UPDATED}`,
] as const;

export const WS_DOM_COLIS = [
  `ws:${WS_EVENTS.COLIS_PARCEL_CREATED}`,
  `ws:${WS_EVENTS.COLIS_PARCEL_RECEIVED}`,
  `ws:${WS_EVENTS.COLIS_PARCEL_READY}`,
  `ws:${WS_EVENTS.COLIS_PARCEL_COLLECTED}`,
  `ws:${WS_EVENTS.COLIS_PARCEL_DELETED}`,
] as const;

export const WS_DOM_SALLE = [
  `ws:${WS_EVENTS.SALLE_RESERVATION_CREATED}`,
  `ws:${WS_EVENTS.SALLE_RESERVATION_UPDATED}`,
  `ws:${WS_EVENTS.SALLE_RESERVATION_DELETED}`,
] as const;
